const getApiUrl = () =>
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

/**
 * Server-provisioned Free Gateway signup (no client Firebase registration).
 * User receives a welcome email with a generated password, same pattern as Stripe checkout.
 */
export async function submitFreeGatewaySignup(payload) {
  const res = await fetch(`${getApiUrl()}/users/free-gateway`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      data?.message ||
      data?.error ||
      `Signup failed (${res.status})`;
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return data;
}
